import script from "./ChatConversationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatConversationPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChatConversationPanel.vue?vue&type=style&index=0&id=0d92bfa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d92bfa8"]])

export default __exports__